import style from "../../Pages/ServicesDisplay.module.css";
import dmt from "../images/ServiceDetailImg/domesticmoneytransfer.png";

const DMT = () => {
  return (
    <article className={style.ServiceDetailArticle}>
      <h1>Domestic Money Transfer</h1>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <picture>
          <img src={dmt}></img>
        </picture>
      </div>
      <p className={style.Paragraph}>
        <strong>
          Fund transfers will now be made easy with Cash to Account. Carry in
          cash and walk-in to any Fino Payments Bank branch or select merchant
          establishments, fill in few details and have the money transferred to
          your loved ones, anywhere in the country.
        </strong>
        <br /> <br />
        Also at our centres, The money, received by the DMR ( Domestic money
        remittance) agent , is transfer processed using National Electronic Fund
        Transfer (NEFT) and Immediate Payment service (IMPS) technology. As you
        shared you own your mobile shop then we believe you already have
        footfall of such customers so can join us any time. Domestic Money
        Transfer. By virtue of the PPI license issued to our organization, we
        offer the direct money transfer service within India for all our
        customers with or without a bank account . It's as simple and secure as
        the customer handing over the money to the beneficiary face-to-face DMT.
        Domestic Money Transfer (DMT): This is a cash to account transfer by
        which our agents can send money to any Nationalized, Private, or Rural
        Bank at any point of time even during bank holidays using NEFT or IMPS.
        The IMPS transaction also enables instant credit to the account. 
      </p>
    </article>
  );
};

export default DMT;
